var map = {
	"./alarm-clock.svg": 37365,
	"./category.svg": 21513,
	"./chart-bar.svg": 71579,
	"./circle-right.svg": 50588,
	"./grade.svg": 54014,
	"./icon-arrow-right.svg": 84991,
	"./icon-side-home.svg": 3818,
	"./icon-side-record.svg": 47084,
	"./icon-side-task.svg": 91660,
	"./icon-side-user.svg": 62734,
	"./icon-wrarning.svg": 40347,
	"./navbar-question.svg": 10492,
	"./navbar-todo-tasks.svg": 77261,
	"./task-end.svg": 58602,
	"./task-flag.svg": 37809,
	"./video-left.svg": 74128,
	"./video-play.svg": 49537,
	"./video-right.svg": 9247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;